import React, { useState } from 'react';

function SongTile({ song, onPick }) {
  return (
    <button type="button" className="gs-song" onClick={() => onPick(song)}>
      <span
        className="gs-song__art"
        style={song.art_url ? { backgroundImage: `url(${song.art_url})` } : undefined}
      >
        {!song.art_url && <span className="gs-song__note">♪</span>}
      </span>
      <span className="gs-song__meta">
        <strong>{song.title}</strong>
        <small>{song.artist}</small>
        <span className="gs-song__tags">
          {song.genre && <em>{song.genre}</em>}
          {song.instrumental_url
            ? <em className="is-ready">backing track</em>
            : <em className="is-missing">a cappella only</em>}
          {song.lrc && <em>synced lyrics</em>}
        </span>
      </span>
    </button>
  );
}

export default function SongLibrary({ songs, loading, onPick, onSearch }) {
  const [query, setQuery] = useState('');

  return (
    <section>
      <form
        className="gs-karaoke__search"
        onSubmit={(e) => { e.preventDefault(); onSearch(query); }}
      >
        <input
          type="search"
          value={query}
          placeholder="Search songs"
          onChange={(e) => setQuery(e.target.value)}
        />
        <button type="submit">Search</button>
      </form>

      {loading && <p className="gs-karaoke__empty">Loading songs…</p>}
      {!loading && !songs.length && (
        <p className="gs-karaoke__empty">
          No songs in the library yet. Originals are added as they are released.
        </p>
      )}

      <div className="gs-karaoke__grid">
        {songs.map((song) => <SongTile key={song.id} song={song} onPick={onPick} />)}
      </div>
    </section>
  );
}
